import PubNub from 'pubnub';
import { LastMessagesMap } from '@/utils/pubnub/pubnub.types';
import { formatMemberships } from '@/utils/pubnub/formatMemberships';
import { getLastMessages } from '@/utils/pubnub/getLastMessages';
import { notifyBugsnagError } from '@/utils/pubnub/notifyBugsnagError';

export const getMembershipsOptions = {
  filter: 'channel.custom != null && channel.custom.lastMessageText != null',
  include: { customFields: true },
  sort: { 'channel.updated': 'desc' },
};

export const getMemberships = async (
  pubNubClient: PubNub,
  notificationChannelName: string,
  setLastMessagesMap: (value: LastMessagesMap) => void,
  retryCount = 0
) => {
  let res;

  try {
    res = await pubNubClient.objects.getMemberships(getMembershipsOptions);

    const { allChannelKeys, customFieldsMap } = formatMemberships(res.data);

    pubNubClient.subscribe({
      channels: [notificationChannelName, ...allChannelKeys],
    });

    if (allChannelKeys.length) {
      const lastMessagesMap = await getLastMessages(
        pubNubClient,
        allChannelKeys,
        customFieldsMap
      );

      if (lastMessagesMap) {
        setLastMessagesMap(lastMessagesMap);
      }
    }
  } catch (e) {
    notifyBugsnagError(e, pubNubClient);
  } finally {
    if (res === undefined) {
      if (retryCount < 2) {
        await getMemberships(
          pubNubClient,
          notificationChannelName,
          setLastMessagesMap,
          retryCount + 1
        );
      }
    }
  }
};
